import { toast } from '@/helpers/toast/toast.helper'
import { t } from 'i18next'
import { call, put } from 'redux-saga/effects'
import { updateUserOnMainApiAction } from '../../actions'
import { devzappApi } from '@/services/api'
import { updatePassword, updateUser } from '../_http/user'

export function* updateUserOnMainApiSaga(action: ReturnType<typeof updateUserOnMainApiAction.request>) {
  try {
    const { userToken, userEmail, userId, password, callback } = action.payload

    yield call(
      [devzappApi, devzappApi.post],
      '/user/updateData',
      { ...(password && { password }) },
      {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      }
    )

    yield call(updatePassword, { email: userEmail, password })
    yield call(updateUser, { id: userId, dataToUpdate: { lastPasswordUpdate: new Date().getTime() } })
    yield put(updateUserOnMainApiAction.success())
    toast({ type: 'success', message: 'Senha atualizada com sucesso.' })
    callback?.()
  } catch (error) {
    console.log({ error })
    yield put(updateUserOnMainApiAction.failure(error))
    toast({ type: 'error', message: t('translation:somethingWentWrong') })
  }
}
